import packageJson from '../../package.json';

export const environment = {
    version: packageJson.version,
    production: true,
    apiPath: '',
    hostName: 'https://test.dev.lagerage.at',
    authPath: 'https://sign-in-test.dev.lagerage.at/auth',
    realm: 'Lagerage',
    clientId: 'angular',
    logoutURL:
        'https://sign-in-test.dev.lagerage.at/auth/realms/Lagerage/protocol/openid-connect/logout',
    stripeKey:
        'pk_test_51L98cVAjypCagBZ2SMXr4uCFwVQszFTcfbOBHq9hKZfduzJHx3AduCc9JtkSTXpHNYFOqPTbsCLQtHeSulADn1A700b7RdPUjs',
    // Nur für die Admin-Standortkarte; wird erst beim Öffnen der Karte nachgeladen (kein Google-Aufruf ohne Bedarf)
    googleMapsKey: 'AIzaSyA2U5SkwCrU26D2yxLU0u6TufFJo35JY_k',
    newsletterFormUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSflVs0o23SGuS0EkA9xzIcHeN7cXMhfzNYdeG_U54XyIRmEiw/viewform?usp=sf_link'
};
